import React, { useEffect, useState } from 'react';
import { Building2, Globe, TrendingUp, Users } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { getHomepageSectionML } from '../../services/api';

const iconMap = {
  'building': Building2,
  'globe': Globe,
  'trending-up': TrendingUp,
  'users': Users
};

const ServicesSectionML = () => {
  const { language } = useLanguage();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServicesContent();
  }, [language]);

  const loadServicesContent = async () => {
    setLoading(true);
    const normalizedLang = ['pt','en','fr','ar','zh'].includes(language) ? language : (language.startsWith('pt') ? 'pt' : 'en');
    const result = await getHomepageSectionML('services', normalizedLang);
    if (result.success) {
      setContent(result.data);
    }
    setLoading(false);
  };

  if (loading || !content) {
    return (
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <div className="animate-pulse">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 md:py-32 bg-[#f8f9fa]">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-8 bg-[#00B4D8]" />
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00B4D8]">{content.label}</p>
            <div className="h-px w-8 bg-[#00B4D8]" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#2B2D42] mb-6 tracking-tight">{content.heading}</h2>
          <p className="text-base md:text-lg text-[#6C757D] font-light">{content.subheading}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.services
            ?.filter(service => service.visible)
            .sort((a, b) => a.order - b.order)
            .map((service, index) => {
              const IconComponent = iconMap[service.icon] || Building2;
              return (
                <div key={service.id || index}
                  className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2 group border border-gray-100">
                  <div className="bg-[#023E8A]/5 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#FF6B35] transition-colors duration-300">
                    <IconComponent className="h-7 w-7 text-[#023E8A] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-bold text-[#2B2D42] mb-3 group-hover:text-[#FF6B35] transition-colors">{service.title}</h3>
                  <p className="text-sm text-[#6C757D] leading-relaxed">{service.description}</p>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSectionML;
